<template>
  <div>
    <modal
      :show.sync="editModal"
      scrollable
      header-classes="bg-primary p-2 flex items-center"
      footerClasses=""
      size="lg"
      bodyClasses=""
    >
      <h6 slot="header" class="modal-title text-white pl-4 font-semibold">
        Edit Chapter Name
      </h6>
      <div>
        <p class="font-semibold text-md pb-1">Chapter Name</p>
        <base-input
          placeholder="Enter Chapter Name"
          class="cust-mb0"
        ></base-input>
      </div>
      <template slot="footer">
        <base-button @click="saveChanges(name)" type="primary"
          >SAVE CHANGES</base-button
        >
        <base-button @click="editModal = false" type="secondary" class="ml-auto"
          >CLOSE</base-button
        >
      </template>
    </modal>
  </div>
</template>

<script>
export default {
  props: {
    editModal: Boolean,

    toggleEditModal: Object,
  },
};
</script>
